import LoginRequiredModal from 'components/Modal/LoginRequiredModal'
import { useModal } from 'contexts/ModalContext'
import { useAuth } from 'contexts/AuthContext'
import React, { useEffect } from 'react'
import Loader from 'components/Loader'

interface ProtectedRouteProps {
  requirement?: 'user' | 'guestOrUser'
  children: JSX.Element
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children, requirement = 'guestOrUser' }) => {
  const { isAuth, isGuest, isAuthInProcess } = useAuth()
  const showModal = useModal()

  useEffect(() => {
    if (isAuthInProcess) return
    if (requirement === 'user' && !isAuth) {
      showModal(
        <LoginRequiredModal
          isHistory={false}
          previousPage
          onClose={() => {
            showModal()
          }}
        />
      )
    } else if (requirement === 'guestOrUser' && !(isGuest || isAuth)) {
      showModal(
        <LoginRequiredModal
          isHistory={false}
          addGuestLoginOption
          previousPage
          onClose={() => {
            showModal()
          }}
        />
      )
    }
  }, [isAuth, isAuthInProcess, isGuest, requirement, showModal])

  if (isAuthInProcess) {
    return <Loader type="full" />
  }

  return children
}

export default ProtectedRoute